import axios from "axios";

export const getLocationByIP = async () => {
  const ipinfo_token = "0b4eb014412481";
  return await axios.get(`https://ipinfo.io/json?token=${ipinfo_token}`);
};
